export default __webpack_public_path__ + "static/media/logotipo-secundario.e704ee3b.svg";